import { render, staticRenderFns } from "./form.vue?vue&type=template&id=44fb3016&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=44fb3016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fb3016",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44fb3016')) {
      api.createRecord('44fb3016', component.options)
    } else {
      api.reload('44fb3016', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=44fb3016&scoped=true&", function () {
      api.rerender('44fb3016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/uikit/form.vue"
export default component.exports